import { DocumentNode, useMutation } from '@apollo/client';
import {
  MarkAllNotificationsAsSeenDocument,
  NotificationsDocument,
} from 'src/graphql/generated/graphql';

export const useMarkAllAsRead = (
  refetchQueries?: DocumentNode[],
) => {
  return useMutation(MarkAllNotificationsAsSeenDocument, {
    refetchQueries: refetchQueries || [NotificationsDocument],
  });
};
